import { Container } from "./style";
import HeroSection from "../../components/landingPage/heroSection";
import LandingNavbar from "../../components/landingPage/navbar";
import SwipeAdSection from "../../components/landingPage/swipeAdSection";
import SocialMediaSection from "../../components/landingPage/socialMediaSection";
import ExploreLoungeSection from "../../components/landingPage/exploreLoungeSection";
import TranScriptSection from "../../components/landingPage/tranScriptSection";
import Footer from "../../components/landingPage/Footer";
import LoungeSection from "../../components/landingPage/loungeSection";
import AboutPlatform from "../../components/landingPage/aboutPlatform";
import OrganizationSection from "../../components/landingPage/organizationSection";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { REACT_APP_BUCKET_URL } from "../../utils/helpers";

const LandingPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, navigate]);
  return (
    <Container>
      <LandingNavbar />
      <HeroSection />
      <LoungeSection />
      <AboutPlatform />
      <SwipeAdSection />
      <SocialMediaSection />
      <OrganizationSection />
      <ExploreLoungeSection />
      <TranScriptSection />
      <Footer />
    </Container>
  );
};

export default LandingPage;
